import { defineMessages } from 'react-intl'

export default defineMessages({
  createDeal: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.CreateDeal.createDeal',
    defaultMessage: 'Create deal',
  },
  syncDeal: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.CreateDeal.syncDeal',
    defaultMessage: 'Sync deal',
  },
  createDealSuccess: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.CreateDeal.createDealSuccess',
    defaultMessage: 'You will be notified when the sync is complete. Please refresh order view, after confirmation\nOrder enqueued to be synced with Bitrix',
  },
  createDealError: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.CreateDeal.createDealError',
    defaultMessage: 'Failed to enqueue deal creation in Bitrix',
  },
})
